import { Navigate, Outlet } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';
import { memo } from 'react';

function PrivateRoute() {
  const { keycloak } = useKeycloak();
  if (!keycloak?.authenticated) {
    return <Navigate to="/sign-in" replace />;
  }
  return <Outlet />;
}

export default memo(PrivateRoute);
